<template>
  <v-card>
    <v-slide-x-transition
      hide-on-leave
      group
    >
      <div
        v-if="selectedServer || (!selectedReservation && !selectedTables.length)"
        key="tabs"
      >
        <v-tabs
          v-model="selectedTab"
          centered
          fixed-tabs
          :show-arrows="false"
        >
          <v-tab key="reservations">
            Reservations
          </v-tab>
          <v-tab key="servers">
            Servers
          </v-tab>
          <!-- <v-tab key="assignments">
            Assignments
          </v-tab> -->
          <v-tab-item key="reservations">
            <reservations-tab
              ref="reservationsTab"
              v-bind="{location, mealPeriod, date, time, showAllReservations, forEvent}"
              @select-reservation="setSelectedReservation"
            />
          </v-tab-item>
          <v-tab-item key="servers">
            <servers-tab
              ref="serversTab"
              v-bind="{date, location, mealPeriod, tableConfigId, serverAssignmentsMap, forEvent, event}"
              @refresh-server-assignments="$emit('refresh-server-assignments')"
              @refresh-meal-period="$emit('refresh-meal-period')"
              @select-server="(server) => {
                selectedServer = server
                $emit('multi-select-mode', !!server)
              }"
              @set-tables="$emit('add-table', $event)"
            />
          </v-tab-item>
          <!-- <v-tab-item key="assignments">
            <assignments-tab
              :location="location"
              :meal-period="mealPeriod"
              :date="date"
            />
          </v-tab-item> -->
        </v-tabs>
        <div
          v-if="selectedTab === 0"
          class="d-flex justify-end white"
          style="position: sticky; bottom: 0px; z-index: 2;"
        >
          <div
            class="text--secondary pr-2 d-flex align-self-center"
            style="cursor: pointer;"
            @click="showAllReservations = !showAllReservations"
          >
            Show ALL Reservations
          </div>
          <v-simple-checkbox
            v-model="showAllReservations"
            :ripple="false"
            color="primary"
          />
        </div>
      </div>
      <selected-open-table
        v-else-if="selectedTables.length"
        key="selected-open-table"
        v-bind="{mealPeriod, serverAssignmentsMap}"
        :tables="selectedTables"
        :date="date"
        @refresh-tables="$emit('refresh-tables')"
        @deselect-open-table="clearSelections()"
      />
      <selected-reservation
        v-else-if="selectedReservation"
        key="selected-reservation"
        :reservation="selectedReservation"
        v-bind="{mealPeriod, date, time, autoClearReservationStatus, tableConfigId, forEvent, event}"
        :meal-period="mealPeriod"
        :date="date"
        :auto-clear-reservation-status="autoClearReservationStatus"
        :table-config-id="tableConfigId"
        @deselect-reservation="() => {
          selectedReservation = undefined
          $emit('refresh-floor-plan')
          $emit('refresh-tables')
        }"
      />
    </v-slide-x-transition>
  </v-card>
</template>

<script>
import mealPeriodHelpers from '../mixins/mealPeriodHelpers'
import ReservationsTab from './reservationsTab/ReservationsTab'
import ServersTab from './serversTab/ServersTab'
import SelectedReservation from './SelectedReservation'
import SelectedOpenTable from './SelectedOpenTable'
import floorPlanHelpers from '../mixins/floorPlanHelpers'
export default {
  name: 'LeftSidePanel',
  components: {ReservationsTab, ServersTab, SelectedReservation, SelectedOpenTable},
  mixins: [mealPeriodHelpers, floorPlanHelpers],
  props: {
    serverAssignmentsMap: {
      type: Object,
      default () {return {}}
    },
    event: {
      type: Object,
      default () {return {}}
    },
    forEvent: Boolean,
    multiSelectMode: Boolean,
    tableConfigId: Number,
    location: Object,
    mealPeriod: Object,
    date: [String, Number],
    time: [String, Number],
    autoClearReservationStatus: Boolean,
  },
  data () {
    return {
      selectedTab: undefined,
      selectedServer: undefined,
      selectedReservation: undefined,
      selectedTables: [],
      showAllReservations: false,
      serverTables: [],
    }
  },
  computed: {
    showSelectedOpenTable () {
      return (this.selectedTables || []).length && !this.selectedServer
    },
    /**
     * @param {Function} get If and only if the length of `selectedTables` is 1, return that table.
     * Otherwise, return undefined
     * @param {Function} set If selectedTable is set directly, change value of selectedTables
     * to the inputted value
     */
    selectedTable: {
      get () {
        if (this.selectedTables?.length === 1) {
          const [table] = this.selectedTables
          return table
        }
        return undefined
      },
      set (value) {
        if (!value) {
          this.selectedTables = []
          return
        }
        if (typeof value !== 'object') return
        this.selectedTables = [value]
      }
    },
    /**
     * `selectedTables` mapped by `r.id` to `r`
     *
     * Also including a local `_index` because we are anticipating removal
     * of items from `selectedTables` by index later on.
     */
    selectedTablesMap () {
      return this.selectedTables?.reduce((acc, r, index) => {
        if (!r) return acc
        r._index = index
        acc[r.id] = r
        return acc
      }, {}) ?? {}
    }
  },
  watch: {
    'mealPeriod.id' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedReservation = undefined
        this.selectedServer = undefined
      }
    },
    selectedServer: {
      handler (newVal) {
        if (newVal != null) {
          this.clearSelections('selectedServer')
          this.$emit('add-table', newVal[this.forEvent ? 'eventTables' : 'tables'].map(t => this.$refs.serversTab?.allTablesMap[t.locationTableId] ?? t))
        } else this.selectedTables = []
      },
      immediate: true
    },
    'selectedReservation.id' (newVal, oldVal) {
      if (newVal == null) this.showAllReservations = false
      else {
        this.clearSelections('selectedReservation')
        if (oldVal == null || newVal !== oldVal) {
          this.$emit('set-time-radar', this.selectedReservation.time)
          this.$emit('scroll-to-selected-reservation', this.selectedReservation.tableAssignments)
        }
      }
    },
    'selectedTable.tableId' (newVal) {if (newVal != null) this.clearSelections('selectedTable')}
  },
  methods: {
    clearSelections (source) {
      for (let field of ['selectedServer', 'selectedReservation', 'selectedTable']) {
        if (field !== source) this[field] = undefined
      }
    },
    /**
     * Adds the passed table to our list of selected tables.
     * If table is already selected, use local _index to deselect it
     * @param {Object} table
     */
    addSelectedTable (table) {
      this.$refs.serversTab?.selectTable(table)
      const mappedTable = this.selectedTablesMap[table.id]
      if (mappedTable) this.selectedTables.splice(mappedTable._index, 1)
      else this.selectedTables.push(table)
    },
    /**
     * Sets the selected table when outside of multi-select mode
     * @param {Object} table
     */
    setSelectedTable (table) {
      this.selectedTable = undefined
      setTimeout(() => this.selectedTable = Object.assign({}, table))
    },
    /**
     * Accessible from parent by ref. Set the value of the `selectedTables` Array
     * @param {Array} tables value to set `selectedTables` to. Array of _DiningLocationTable_ Objects
     * @see selectedTables
     */
    setSelectedTables (tables) {
      setTimeout(() => this.selectedTables = tables)
    },
    setSelectedReservation (reservation) {
      if (!this.forEvent && reservation?.mealPeriodId !== this.mealPeriod.id) {
        this.$emit('set-floor-plan-data', reservation.locationId, reservation.mealPeriodId)
        this.$nextTick(() => {
          this.selectedReservation = undefined
          setTimeout(() => this.selectedReservation = reservation)
        })
      } else {
        if (this.selectedReservation) {
          this.selectedReservation = undefined
          setTimeout(() => this.selectedReservation = reservation)
        } else this.selectedReservation = reservation
      }
    },
    refreshSelectedReservation () {
      if (!this.selectedReservation) return
      this.$ftAPI().get(this.addResourceErrorHandler({
        command: 'diningReservation',
        afterLoad: (r) => {
          this.selectedReservation = r?.[0] ?? {}
        },
        loading: this.isLoading,
        params: {
          children: true,
          include_fields: ['diningReservationDetail.member'],
          filter: [{field: 'id', operator: 'EQUAL', values: [this.selectedReservation?.id]}]
        }
      }))
    }
  }
}
</script>

<style scoped>
.ft-floor-plan-tabs >>> .v-slide-group {
  position: sticky;
  top: 0px;
  z-index: 2;
}
.ft-floor-plan-tabs >>> .v-slide-group .v-slide-group__prev,
.ft-floor-plan-tabs >>> .v-slide-group .v-slide-group__next {
  display: none !important;
}
</style>
